import React from 'react';
import { jwtDecode } from 'jwt-decode'; // Ensure this package is installed
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Users from './pages/Users';
import Applications from './pages/Applications';
import RAMappings from './pages/RAMappings';
import RAProfiles from './pages/RAProfiles';
import Organizations from './pages/Organizations';
import Consumptions from './pages/Consumptions';
import ApplicationsForm from './pages/ApplicationsForm';
import RAMappingForm from './pages/RAMappingForm';
import RAProfileForm from './pages/RAProfileForm';
import OrganizationsForm from './pages/OrganizationsForm';
import UsersForm from './pages/UsersForm';
import UserViewer from './pages/UserViewer';
import LoadCreditPage from './pages/LoadCredit';
import TransferCreditPage from './pages/TransferCreditPage';
import UserWithApplications from './pages/UserWithdraw';
import UserApplication from './pages/UserApplication';
import UserProfile from './pages/UserProfile';
import UserInitialize from './pages/UserInitialize';
import UsersResetPassword from './pages/UserResetPassword';
import UserCreate from './pages/UserCreate';
import Sidebar from './components/Sidebar';
import { Box, Toolbar } from '@mui/material';

function ProtectedRoute({ children }) {
  const { user, token } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const decodedToken = jwtDecode(token);
  return children;
}

function Layout({ children }) {
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar /> {/* Spacer for the fixed Sidebar */}
        {children}
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Layout><Users /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users/:id/update"
          element={
            <ProtectedRoute>
              <Layout><UsersForm /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users/:id/initialize"
          element={
            <ProtectedRoute>
              <Layout><UserInitialize /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applications"
          element={
            <ProtectedRoute>
              <Layout><Applications /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ra"
          element={
            <ProtectedRoute>
              <Layout><RAMappings /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ra/:id/update"
          element={
            <ProtectedRoute>
              <Layout><RAMappingForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ra/create"
          element={
            <ProtectedRoute>
              <Layout><RAMappingForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ra-profiles"
          element={
            <ProtectedRoute>
              <Layout><RAProfiles /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ra-profiles/:id/update"
          element={
            <ProtectedRoute>
              <Layout><RAProfileForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/ra-profiles/create"
          element={
            <ProtectedRoute>
              <Layout><RAProfileForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/consumptions"
          element={
            <ProtectedRoute>
              <Layout><Consumptions /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applications/:id/update"
          element={
            <ProtectedRoute>
              <Layout><ApplicationsForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/applications/create"
          element={
            <ProtectedRoute>
              <Layout><ApplicationsForm /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations"
          element={
            <ProtectedRoute>
              <Layout><Organizations /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizations/:id/update"
          element={
            <ProtectedRoute>
              <Layout><OrganizationsForm /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/user/:id"
          element={
            <ProtectedRoute>
              <Layout><UserViewer /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={<Navigate to="/users" replace />}
        />

        <Route path="/user/:id/:app/load"
          element={
            <ProtectedRoute>
              <Layout>
                <LoadCreditPage />
              </Layout>
            </ProtectedRoute>
          }

        />
        <Route path="/user/:id/:app/transfer"
          element={
            <ProtectedRoute>
              <Layout>
                <TransferCreditPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/:id/:app/withdraw"
          element={
            <ProtectedRoute>
              <Layout><UserWithApplications /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user/:id/applications/:app"
          element={
            <ProtectedRoute>
              <Layout><UserApplication /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout><UserProfile /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/update-password"
          element={
            <ProtectedRoute>
              <Layout><UsersResetPassword /></Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-user"
          element={
            <ProtectedRoute>
              <Layout><UserCreate /></Layout>
            </ProtectedRoute>
          }
        />
      </Routes>

    </Router>
  );
}

export default App;
